import FadeHandler from "components/general/FadeHandler";
import { Box, Button, Link, Text, VStack } from "components/ui";
import { usePathname } from "expo-router";
import { BookPlus, BookText, ChevronDown, ChevronLeft, ChevronRight, CircleHelp, ClipboardCheck, Home, LandPlot, ListChecks, MapPin, ScanBarcode, ShieldCheck, UsersRound } from "lucide-react-native";
import React from "react";
import Animated, { useAnimatedStyle, useSharedValue, withTiming } from "react-native-reanimated";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { useIsAdminSection } from "utils/hooks/useSiteSection";
export const adminNavigationCollection = [
	{
		title: "Sites + Groups",
		href: "/admin/groups",
		icon: <MapPin width={28} height={28} color={"#173648"} />,
	},
	{
		title: "Users",
		href: "/admin/users",
		icon: <UsersRound width={28} height={28} color={"#173648"} />,
	},
	{
		title: "Stocklists",
		href: "/admin/stocklists",
		icon: <ClipboardCheck width={28} height={28} color={"#173648"} />,
	},
	{
		title: "Catalogues",
		href: "/admin/catalogues",
		icon: <BookText width={28} height={28} color={"#173648"} />,
	},
	{
		title: "Roles",
		href: "/admin/roles",
		icon: <ShieldCheck width={28} height={28} color={"#173648"} />,
	},

	// {
	// 	title: "Checklists",
	// 	href: "/admin/checklists",
	// 	icon: <ListChecks width={28} height={28} color={"#173648"} />,
	// },
	{
		title: "GL Accounts",
		href: "/admin/glaccounts",
		icon: <ScanBarcode width={28} height={28} color={"#173648"} />,
	},
];
export default function AdminNavigation() {
	const isAdmin = useIsAdminSection();
	let currentPath = usePathname();
	const [isAdminMenuOpen, setIsAdminMenuOpen] = React.useState(false);
	const [expanded, setExpanded] = React.useState(false);
	const width = useSharedValue(100);
	const isMobile = useIsMobile();
	const animatedStyle = useAnimatedStyle(() => {
		return {
			width: withTiming(width.value, {
				duration: 100,
			}),
		};
	});
	const toggleExpand = () => {
		setExpanded(!expanded);
		width.value = expanded ? 100 : 175;
	};
	if (isMobile) {
		return (
			<>
				<Box>
					<Box>
						<Button paddingHorizontal={24} paddingVertical={16} onPress={() => setIsAdminMenuOpen(!isAdminMenuOpen)} borderRadius={0} width={"$full"} flexDirection="row" justifyContent="space-between" bg="$primarylight">
							<Text color="$basicwhite">Admin</Text>
							<ChevronDown width={28} height={28} color={"white"} />
						</Button>
					</Box>
				</Box>
				{isAdminMenuOpen && (
					<FadeHandler zIndex={2} width={"100%"} top={0} bg="white" height={"100%"} position="absolute">
						<Box>
							<Link href={"/admin"}>
								<Box bg="$neutral25" flexDirection="row" gap={4} padding={24} alignItems="center" justifyContent="center">
									<ChevronLeft color="black" />
									<Text>Back to admin</Text>
								</Box>
							</Link>
							<Box bg="$basicwhite" flexDirection="row" flexWrap="wrap">
								{adminNavigationCollection.map((nav, index) => {
									if (nav.title === "Roles") return null;
									let isSelected = currentPath.startsWith(nav.href);
									return (
										<Link
											key={index}
											href={nav.href}
											pressableStyle={{
												flexBasis: "50%",
											}}
											onPress={() => setIsAdminMenuOpen(!isAdminMenuOpen)}
											component={(hovered) => {
												let bg = isSelected ? "$lighttealxlight" : "$basicwhite";
												if (hovered) bg = "$lighttealxlight";

												return (
													<Box
														paddingVertical={24}
														gap={6}
														bg={bg}
														borderColor={isSelected ? "$primarylightblue" : "transparent"}
														borderTopWidth={6}
														alignItems="center"
														justifyContent={expanded ? "flex-start" : "center"}
													>
														<Box>{nav.icon}</Box>
														<Box>
															<Text fontSize={14}>{nav.title}</Text>
														</Box>
													</Box>
												);
											}}
										/>
									);
								})}
							</Box>
							<Box height={"$full"} bg="$neutral25" flexDirection="row">
								<Box flex={1}>
									<Button gap={8} paddingVertical={32}>
										<CircleHelp color="black" />
										<Text>Help</Text>
									</Button>
								</Box>
								<Box flex={1}>
									<Button gap={8} paddingVertical={32}>
										<LandPlot color="black" />
										<Text>Tour</Text>
									</Button>
								</Box>
							</Box>
						</Box>
					</FadeHandler>
				)}
			</>
		);
	}
	return (
		<Animated.View style={animatedStyle}>
			<VStack width={"$full"} onPointerLeave={toggleExpand} onPointerEnter={toggleExpand} borderRightWidth={1} borderColor="$neutral100">
				<Box paddingHorizontal={expanded ? 36 : 0} justifyContent={expanded ? "flex-start" : "center"} w={"$full"} flexDirection="row" alignItems="center" bg="$primarylight" h={100}>
					<Home width={28} height={28} color={"white"} />

					{expanded && (
						<Box flexDirection="row" alignItems="center">
							<ChevronRight width={28} height={28} color={"white"} />
							<Text color="$basicwhite">Admin</Text>
						</Box>
					)}
				</Box>
				{adminNavigationCollection.map((nav) => {
					let isSelected = currentPath.startsWith(nav.href);

					return (
						<Link
							key={nav.href}
							href={nav.href}
							component={(hovered) => {
								let bg = isSelected ? "$lighttealxlight" : "$basicwhite";
								if (hovered) bg = "$lighttealxlight";

								return (
									<Box
										flexDirection="row"
										paddingHorizontal={expanded ? 36 : 0}
										gap={6}
										w={"$full"}
										h={100}
										bg={bg}
										borderColor="$primarylightblue"
										borderRightWidth={isSelected ? 6 : 0}
										alignItems="center"
										justifyContent={expanded ? "flex-start" : "center"}
									>
										<Box>{nav.icon}</Box>
										<Box>{expanded && <Text fontSize={14}>{nav.title}</Text>}</Box>
									</Box>
								);
							}}
						/>
					);
				})}
			</VStack>
		</Animated.View>
	);
}
